import React from 'react';
import Helmet from 'react-helmet';
import Page from './components/template/page';

import { Transition, TransitionGroup } from 'react-transition-group';
import { Global, css } from '@emotion/core';
import { fontYugo, baseDurationTime, mq, black01, base } from './_style';
import { reset } from './_resetStyle';
import Footer from './components/organisms/footer';

const timeout = 800;

export default class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = { top: 0 };
  }
  componentDidMount() {
    document.body.classList.add('is-loaded');
  }
  render() {
    const { children, location } = this.props;
    let topPos = 0;
    return (
      <div className='ssite'>
        <Global
          styles={css`
            ${reset}
            ${base}
          body {
              color: ${black01};
              font-family: ${fontYugo};
              font-size: 15px;
              font-weight: 500;
              letter-spacing: 0.03em;
              opacity: 0;
              transition: opacity ${baseDurationTime} ease;
              ${mq.pc} {
                margin: auto;
              }
              ${mq.sp} {
              }
              &.is-loaded {
                opacity: 1;
              }
            }
          `}
        ></Global>
        <Helmet>
          <meta charSet="utf-8" />
          <meta httpEquiv="x-ua-compatible" content="ie=edge" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <title>口臭、歯肉炎、むし歯などのお口トラブル予防に モンダミン | アース製薬</title>
          <meta name="keywords" content="マウスウォッシュ,洗口液,液体ハミガキ,液体歯磨き,モンダミン,もんだみん,mondahmin,口臭,口臭ケア,むし歯,歯肉炎,歯周病,歯周炎,オーラルケア,アース製薬" />
          <meta name="description" content="お口トラブル（口臭・歯肉炎・むし歯など）の原因となる食べカスやミクロのよごれ、ネバネバをしっかり洗い流すマウスウォッシュ（洗口液・液体ハミガキ）の「モンダミン」公式サイト。悩みに合わせて選べる豊富なラインナップでお口の健康を守ります。" />
          <meta name="thumbnail" content="https://www.earth.jp/mondahmin/main_img.png"></meta>
          <meta property="og:site_name" content="口臭、歯肉炎、むし歯などのお口トラブル予防に モンダミン | アース製薬" />
          <meta property="og:title" content="口臭、歯肉炎、むし歯などのお口トラブル予防に モンダミン | アース製薬" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.earth.jp/mondahmin/" />
          <meta property="og:image" content="https://www.earth.jp/mondahmin/og.jpg" />
          <meta property="og:description" content="お口トラブル（口臭・歯肉炎・むし歯など）の原因となる食べカスやミクロのよごれ、ネバネバをしっかり洗い流すマウスウォッシュ（洗口液・液体ハミガキ）の「モンダミン」公式サイト。悩みに合わせて選べる豊富なラインナップでお口の健康を守ります。" />
          <meta property="og:locale" content="ja_JP" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="口臭、歯肉炎、むし歯などのお口トラブル予防に モンダミン | アース製薬" />
          <meta name="twitter:description" content="お口トラブル（口臭・歯肉炎・むし歯など）の原因となる食べカスやミクロの汚れ、ネバネバをしっかり洗い流すマウスウォッシュ（洗口液）の「モンダミン」公式サイト。悩みに合わせて選べる豊富なラインナップでお口の健康を守ります。" />
          <meta name="twitter:image" content="https://www.earth.jp/mondahmin/og.jpg" />
          <link rel="shortcut icon" href="https://www.earth.jp/mondahmin/favicon.ico"></link>
          <link rel="stylesheet" type="text/css" href="/common/css/common.css"></link>
        </Helmet>
        <div id={'global-header'}></div>
        <TransitionGroup
          component={null}
          childFactory={child =>
            React.cloneElement(child, { timeout: timeout })
          }
        >
          <Transition
            appear={true}
            key={location.key}
            timeout={timeout}
            onExit={() => {
              topPos = window.pageYOffset;
            }}
          >
            {status => (
              <Page
                transitionStatus={status}
                className={`is-${status}`}
                top={topPos}
              >
                {children}
              </Page>
            )}
          </Transition>
        </TransitionGroup>
        <Footer></Footer>
        <div id={'global-footer'}></div>
      </div>
    );
  }
}
